import {
  GET_EVENT_PLANNING_REQUEST,
  SET_EVENT_PLANNING,
  EVENT_PLANNING_LOADING,
} from "./Types";

export const EventPlanningLoading = (loading, type) => {
  return {
    type: EVENT_PLANNING_LOADING,
    payload: { loading, type },
  };
};

export const GetEventPlanningSuccess = (data) => {
  return {
    type: GET_EVENT_PLANNING_REQUEST,
    payload: data,
  };
};

export const SetEventPlanning = (data) => {
  return {
    type: SET_EVENT_PLANNING,
    payload: data,
  };
};
